import {
  applySnapshot,
  getSnapshot,
  Instance,
  SnapshotIn,
  types,
} from 'mobx-state-tree';
import { LoadingState, LoadingStates } from 'globals/types';
import { RangeTime, RangeTimeProps } from 'models/reusable-parts/range-time';
import { CashflowSummaryItemProps } from 'components/UserPanel/Pages/Report/ReportCashflowSummarySection/CashflowSummaryItem/CashflowSummaryItem';
import {
  CashflowSummarySingleItem,
  CashflowSummarySingleItemProps,
} from './cashflow-summary-single-item';

export interface CashflowSummaryProps {
  data: CashflowSummarySingleItemProps[];
  rangeTime?: RangeTimeProps;
  status: LoadingState;
}

export const CashflowSummary = types
  .model({
    data: types.optional(types.array(CashflowSummarySingleItem), []),
    rangeTime: types.maybe(RangeTime),
    status: types.optional(
      types.enumeration(LoadingStates),
      LoadingState.INITIAL
    ),
  })
  .actions((self) => ({
    set(props: CashflowSummaryProps): void {
      const currentSnapshot = getSnapshot(self);
      const newSnapshot = {
        ...currentSnapshot,
        ...props,
      };
      applySnapshot(self, newSnapshot);
    },
    updateStatus(status: LoadingState): void {
      const currentSnapshot = getSnapshot(self);
      const newSnapshot = {
        ...currentSnapshot,
        status,
      };
      applySnapshot(self, newSnapshot);
    },
  }))
  .views((self) => ({
    rows(): CashflowSummaryItemProps[] {
      return self.data.map(({ label, value }) => ({
        label,
        value: value.displayValue(),
      }));
    },
  }));

export type CashflowSummarySnapshot = SnapshotIn<typeof CashflowSummary>;
export type CashflowSummaryInstance = Instance<typeof CashflowSummary>;
